(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dhtmlxscheduler", [], factory);
	else if(typeof exports === 'object')
		exports["dhtmlxscheduler"] = factory();
	else
		root["dhtmlxscheduler"] = factory();
})(window, function() {
return 